export default __webpack_public_path__ + "static/media/319.02e4871d.jpg";